(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jbs-home-reference-v4"] && !Shopify.designMode) return;
  try {
    
/* JBS v4: lightweight progressive enhancement for scroll-triggered number counters. */
(() => {
  const selector = '#JbsHomeReferenceV3 .jhv4-stats-wrap';
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const supportsObserver = 'IntersectionObserver' in window;
  function animateStats(section) {
    const counters = section.querySelectorAll('[data-jbs-countup]');
    const start = performance.now();
    const duration = 1350;
    const step = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      counters.forEach((element) => {
        const target = Number(element.dataset.target);
        if (!Number.isFinite(target)) return;
        const suffix = element.dataset.suffix || '';
        const count = progress === 1 ? target : Math.round(target * eased);
        element.textContent = String(count) + suffix;
      });
      if (progress < 1) window.requestAnimationFrame(step);
    };
    window.requestAnimationFrame(step);
  }
  function setup(root) {
    if (reduceMotion || !supportsObserver) return;
    const sections = root.matches && root.matches(selector) ? [root] : root.querySelectorAll(selector);
    sections.forEach((section) => {
      if (section.dataset.jbsCounterReady) return;
      section.dataset.jbsCounterReady = 'true';
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          animateStats(entry.target);
          observer.disconnect();
        });
      }, { threshold: 0.3 });
      observer.observe(section);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setup(document), { once: true });
  } else {
    setup(document);
  }
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jbs-mobile-quality-preview"]) return;
  try {
    
function jbsMobileQaInit(root){root.querySelectorAll('[data-mobile-qa]').forEach(qa=>{
 const select=qa.querySelector('[data-qa-width]');const frame=qa.querySelector('iframe');
 const home=document.querySelector('#JbsHomeReferenceV3');const footer=document.querySelector('footer');
 if(!home)return;
 const styles=Array.from(document.querySelectorAll('style,link[rel="stylesheet"]')).map(node=>node.outerHTML).join('');
 const content=home.outerHTML.replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi,'');
 frame.srcdoc='<!doctype html><html lang="en"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><base href="'+location.origin+frame.dataset.previewBase+'" target="_top">'+styles+'</head><body class="'+document.body.className+'"><div class="page-wrapper"><main id="MainContent">'+content+'</main>'+(footer?footer.outerHTML:'')+'</div></body></html>';
 select.addEventListener('change',()=>{frame.style.width=select.value+'px';frame.width=select.value;});
 });}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>jbsMobileQaInit(document));}else{jbsMobileQaInit(document);}
document.addEventListener('shopify:section:load',event=>jbsMobileQaInit(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jbs-v4-stats"]) return;
  try {
    

/* JBS v4: lightweight progressive enhancement for scroll-triggered number counters. */
(() => {
  const selector = '.jbs-home-modular .jhv4-stats-wrap';
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const supportsObserver = 'IntersectionObserver' in window;
  function animateStats(section) {
    const counters = section.querySelectorAll('[data-jbs-countup]');
    const start = performance.now();
    const duration = 1350;
    const step = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      counters.forEach((element) => {
        const target = Number(element.dataset.target);
        if (!Number.isFinite(target)) return;
        const suffix = element.dataset.suffix || '';
        const count = progress === 1 ? target : Math.round(target * eased);
        element.textContent = String(count) + suffix;
      });
      if (progress < 1) window.requestAnimationFrame(step);
    };
    window.requestAnimationFrame(step);
  }
  function setup(root) {
    if (reduceMotion || !supportsObserver) return;
    const sections = root.matches && root.matches(selector) ? [root] : root.querySelectorAll(selector);
    sections.forEach((section) => {
      if (section.dataset.jbsCounterReady) return;
      section.dataset.jbsCounterReady = 'true';
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          animateStats(entry.target);
          observer.disconnect();
        });
      }, { threshold: 0.3 });
      observer.observe(section);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setup(document), { once: true });
  } else {
    setup(document);
  }
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
